import {
  PARTNER_ID_3Z_PROPERTIES,
  PARTNER_ID_HOMERIVER,
  PARTNER_ID_STONE_OAK,
} from 'common/partnerConstants';

export const JOB_ORDER_STATUS_CREATED = 'Created';
export const JOB_ORDER_STATUS_ASSIGNED = 'Assigned';
export const JOB_ORDER_STATUS_ACCEPTED = 'Accepted';
export const JOB_ORDER_STATUS_COMPLETED = 'Completed';
export const JOB_ORDER_STATUS_FAILED = 'Failed';
export const JOB_ORDER_STATUS_CANCELLED = 'Cancelled';

export const JOB_ORDER_STATUS_LIST = [
  JOB_ORDER_STATUS_CREATED,
  JOB_ORDER_STATUS_ASSIGNED,
  JOB_ORDER_STATUS_ACCEPTED,
  JOB_ORDER_STATUS_COMPLETED,
  JOB_ORDER_STATUS_FAILED,
  JOB_ORDER_STATUS_CANCELLED,
];

export const JOB_STATUS_CREATED = 'Created';
export const JOB_STATUS_COMPLETED = 'Completed';
export const JOB_STATUS_FAILED = 'Failed';
export const JOB_STATUS_CANCELLED = 'Cancelled';

export const JOB_STATUS_LIST = [
  JOB_STATUS_CREATED,
  JOB_STATUS_COMPLETED,
  JOB_STATUS_FAILED,
  JOB_STATUS_CANCELLED,
];

export const JOB_PHOTOGRAPHY_STATUS_SUBMITTED = 'submitted';
export const JOB_PHOTOGRAPHY_STATUS_PULLED = 'pulled';
export const JOB_PHOTOGRAPHY_STATUS_OPEN = 'open';
export const JOB_PHOTOGRAPHY_STATUS_ARRIVED = 'arrived';
export const JOB_PHOTOGRAPHY_STATUS_TRIP_COMPLETE = 'tripComplete';
export const JOB_PHOTOGRAPHY_STATUS_UPLOADED = 'uploaded';

export const JOB_TYPE_YARD_SIGN_SETUP = 'yardSignSetup';
export const JOB_TYPE_SUNLOCK_INSTALL = 'sunlockInstall';
export const JOB_TYPE_SUPRA_LOCK_INSTALL = 'supraLockInstall';
export const JOB_TYPE_COMBO_LOCK_INSTALL = 'comboLockInstall';
export const JOB_TYPE_CODEBOX_INSTALL = 'codeboxInstall';
export const JOB_TYPE_YARD_SIGN_TAKEDOWN = 'yardSignTakedown';
export const JOB_TYPE_SUNLOCK_TAKEDOWN = 'sunlockTakedown';
export const JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP = 'sunlockTakedownAndSwap';
export const JOB_TYPE_SUPRA_LOCK_TAKEDOWN = 'supraLockTakedown';
export const JOB_TYPE_COMBO_LOCK_TAKEDOWN = 'comboLockTakedown';
export const JOB_TYPE_CODEBOX_TAKEDOWN = 'codeboxTakedown';
export const JOB_TYPE_CONDITION_REPORT = 'conditionReport';
export const JOB_TYPE_PROPERTY_CHECK = 'propertyCheck';
export const JOB_TYPE_MEDIA = 'media';
export const JOB_TYPE_MEDIA_CURBSHOT = 'curbshot';
export const JOB_TYPE_MEDIA_3D_TOUR = '3dTour';
export const JOB_TYPE_SPECIAL_REQUEST = 'specialRequest';
export const JOB_TYPE_FIX = 'fix';
export const JOB_TYPE_REPLACE_SUNLOCK_BATTERY = 'replaceSunlockBattery';
export const JOB_TYPE_CHECK_DOOR_LOCK = 'checkDoorLock';
export const JOB_TYPE_CONFIRM_LISTING_INFORMATION = 'confirmListingInformation';

export const MEDIA_JOB_TYPE = [JOB_TYPE_MEDIA, JOB_TYPE_MEDIA_CURBSHOT];

export const INSTALL_JOB_TYPES = [
  JOB_TYPE_SUPRA_LOCK_INSTALL,
  JOB_TYPE_SUNLOCK_INSTALL,
  JOB_TYPE_YARD_SIGN_SETUP,
  JOB_TYPE_COMBO_LOCK_INSTALL,
  JOB_TYPE_CODEBOX_INSTALL,
];

const UNINSTALL_JOB_TYPES = [
  JOB_TYPE_YARD_SIGN_TAKEDOWN,
  JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
  JOB_TYPE_SUNLOCK_TAKEDOWN,
  JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP,
  JOB_TYPE_COMBO_LOCK_TAKEDOWN,
  JOB_TYPE_CODEBOX_TAKEDOWN,
];

export const FIX_JOB_TYPES = [
  JOB_TYPE_FIX,
  JOB_TYPE_REPLACE_SUNLOCK_BATTERY,
  JOB_TYPE_CHECK_DOOR_LOCK,
];

export const JOB_TYPE_TO_UNINSTALL_JOB_TYPE = {
  [JOB_TYPE_YARD_SIGN_SETUP]: JOB_TYPE_YARD_SIGN_TAKEDOWN,
  [JOB_TYPE_SUNLOCK_INSTALL]: JOB_TYPE_SUNLOCK_TAKEDOWN,
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
  [JOB_TYPE_COMBO_LOCK_INSTALL]: JOB_TYPE_COMBO_LOCK_TAKEDOWN,
  [JOB_TYPE_CODEBOX_INSTALL]: JOB_TYPE_CODEBOX_TAKEDOWN,
};

export const JOB_TYPES = [
  JOB_TYPE_YARD_SIGN_SETUP,
  JOB_TYPE_SUNLOCK_INSTALL,
  JOB_TYPE_SUPRA_LOCK_INSTALL,
  JOB_TYPE_COMBO_LOCK_INSTALL,
  JOB_TYPE_CODEBOX_INSTALL,
  JOB_TYPE_YARD_SIGN_TAKEDOWN,
  JOB_TYPE_SUNLOCK_TAKEDOWN,
  JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP,
  JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
  JOB_TYPE_COMBO_LOCK_TAKEDOWN,
  JOB_TYPE_CODEBOX_TAKEDOWN,
  JOB_TYPE_CONDITION_REPORT,
  JOB_TYPE_PROPERTY_CHECK,
  JOB_TYPE_MEDIA,
  JOB_TYPE_MEDIA_CURBSHOT,
  JOB_TYPE_MEDIA_3D_TOUR,
  JOB_TYPE_SPECIAL_REQUEST,
  JOB_TYPE_FIX,
  JOB_TYPE_REPLACE_SUNLOCK_BATTERY,
  JOB_TYPE_CHECK_DOOR_LOCK,
  JOB_TYPE_CONFIRM_LISTING_INFORMATION,
];

export const JOB_TO_ICON_MAPPING = {
  [JOB_TYPE_YARD_SIGN_SETUP]: '🪧',
  [JOB_TYPE_SUNLOCK_INSTALL]: '☀️',
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: '🟦',
  [JOB_TYPE_COMBO_LOCK_INSTALL]: '🔐',
  [JOB_TYPE_CODEBOX_INSTALL]: '🔢',
  [JOB_TYPE_YARD_SIGN_TAKEDOWN]: '🪧',
  [JOB_TYPE_SUNLOCK_TAKEDOWN]: '☀️',
  [JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP]: '☀️',
  [JOB_TYPE_SUPRA_LOCK_TAKEDOWN]: '🟦',
  [JOB_TYPE_COMBO_LOCK_TAKEDOWN]: '🔐',
  [JOB_TYPE_CODEBOX_TAKEDOWN]: '🔢',
  [JOB_TYPE_CONDITION_REPORT]: '🔍',
  [JOB_TYPE_PROPERTY_CHECK]: '🏚️',
  [JOB_TYPE_MEDIA]: '📸',
  [JOB_TYPE_MEDIA_CURBSHOT]: '🏡',
  [JOB_TYPE_MEDIA_3D_TOUR]: '🎥',
  [JOB_TYPE_SPECIAL_REQUEST]: '🌟',
  [JOB_TYPE_FIX]: '🔧',
  [JOB_TYPE_REPLACE_SUNLOCK_BATTERY]: '🔋',
  [JOB_TYPE_CHECK_DOOR_LOCK]: '🔒',
  [JOB_TYPE_CONFIRM_LISTING_INFORMATION]: '📋',
};

export const hasMediaJobType = (jobs) => {
  return jobs.some(({ jobTypeId }) => {
    return MEDIA_JOB_TYPE.includes(jobTypeId);
  });
};

export const hasInstallJobType = (jobs) => {
  return jobs.some(({ jobTypeId }) => {
    return INSTALL_JOB_TYPES.includes(jobTypeId);
  });
};

export const hasFixJobType = (jobs) => {
  return jobs.some(({ jobTypeId }) => {
    return FIX_JOB_TYPES.includes(jobTypeId);
  });
};

export const hasUninstallJobType = (jobs) => {
  return jobs.some(({ jobTypeId }) => {
    return UNINSTALL_JOB_TYPES.includes(jobTypeId);
  });
};

export const DRIVER_STATUS_ACTIVE = 'Active';
export const DRIVER_STATUS_INACTIVE = 'Inactive';

export const DRIVER_STATUS_LIST = [DRIVER_STATUS_ACTIVE, DRIVER_STATUS_INACTIVE];

export const SIGN_OTTER_JOB_TYPE_UNINSTALL = 'uninstall';
export const SIGN_OTTER_JOB_TYPE_INSTALL = 'install';
export const SIGN_OTTER_JOB_TYPE_PROPERTY_CHECK = 'property_check';
export const SIGN_OTTER_JOB_TYPE_MEDIA = 'media';
export const SIGN_OTTER_JOB_TYPE_FIX = 'fix';

export const SIGN_OTTER_JOB_STATUS_INSTALLED = 'installed';
export const SIGN_OTTER_JOB_STATUS_NOT_INSTALLED = 'not installed';
export const SIGN_OTTER_JOB_STATUS_RETRIEVED = 'retrieved';
export const SIGN_OTTER_JOB_STATUS_NOT_RETRIEVED = 'not retrieved';

export const SIGN_OTTER_ORDER_STATUS_SUBMITTED = 'submitted';
export const SIGN_OTTER_ORDER_STATUS_COMPLETE = 'complete';
export const SIGN_OTTER_ORDER_STATUS_INCOMPLETE = 'incomplete';
export const SIGN_OTTER_ORDER_STATUS_DRAFT = 'draft';

export const SIGN_OTTER_ITEM_TYPE_SUNLOCK = 'doorlock';
export const SIGN_OTTER_ITEM_TYPE_SUPRA_LOCK = 'lockbox';
export const SIGN_OTTER_ITEM_TYPE_COMBO_LOCK = 'combination_lockbox';
export const SIGN_OTTER_ITEM_TYPE_YARD_SIGN = 'sign';

export const SIGN_OTTER_ITEM_TYPES = [
  SIGN_OTTER_ITEM_TYPE_SUNLOCK,
  SIGN_OTTER_ITEM_TYPE_SUPRA_LOCK,
  SIGN_OTTER_ITEM_TYPE_COMBO_LOCK,
  SIGN_OTTER_ITEM_TYPE_YARD_SIGN,
];

export const SIGN_OTTER_SKU_TOP_RIDER_DEFAULT = 7433;
export const SIGN_OTTER_SKU_PANEL_DEFAULT = 2268;

export const SIGN_OTTER_YARD_SIGN_TYPE_POST = 'post';
export const SIGN_OTTER_YARD_SIGN_TYPE_FRAME = 'frame';

export const srJobTypeTextMapping = {
  [JOB_TYPE_YARD_SIGN_SETUP]: 'Yard Sign',
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: 'Supra Lockbox',
  [JOB_TYPE_SUNLOCK_INSTALL]: 'Sunlock',
  [JOB_TYPE_COMBO_LOCK_INSTALL]: 'Combo Lockbox',
  [JOB_TYPE_CODEBOX_INSTALL]: 'CodeBox',

  [JOB_TYPE_YARD_SIGN_TAKEDOWN]: 'Yard Sign',
  [JOB_TYPE_SUPRA_LOCK_TAKEDOWN]: 'Supra Lockbox',
  [JOB_TYPE_SUNLOCK_TAKEDOWN]: 'Sunlock',
  [JOB_TYPE_COMBO_LOCK_TAKEDOWN]: 'Combo Lockbox',
  [JOB_TYPE_CODEBOX_TAKEDOWN]: 'CodeBox',
  [JOB_TYPE_PROPERTY_CHECK]: 'Property Check',
  [JOB_TYPE_MEDIA]: 'Media',
  [JOB_TYPE_MEDIA_CURBSHOT]: 'Curbshot',
  [JOB_TYPE_MEDIA_3D_TOUR]: '3D Tour',
  [JOB_TYPE_FIX]: 'Fix',
  [JOB_TYPE_CONDITION_REPORT]: 'Property Condition Report',
  [JOB_TYPE_SPECIAL_REQUEST]: 'Special Request',
  [JOB_TYPE_REPLACE_SUNLOCK_BATTERY]: 'Replace Sunlock Battery',
  [JOB_TYPE_CHECK_DOOR_LOCK]: 'Check Door Lock',
  [JOB_TYPE_CONFIRM_LISTING_INFORMATION]: 'Confirm Listing Information',
};

export const srJobTypeToJobLabelMapping = {
  [JOB_TYPE_CONDITION_REPORT]: 'Condition Report',
  [JOB_TYPE_PROPERTY_CHECK]: 'Property Check',
  [JOB_TYPE_MEDIA]: 'Media',
  [JOB_TYPE_MEDIA_CURBSHOT]: 'Curbshot',
  [JOB_TYPE_MEDIA_3D_TOUR]: '3D Tour Scan',
  [JOB_TYPE_SPECIAL_REQUEST]: 'Special Request',
  [JOB_TYPE_FIX]: 'Fix',
  [JOB_TYPE_YARD_SIGN_SETUP]: 'Yard Sign Setup',
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: 'Supra Lockbox Install',
  [JOB_TYPE_SUNLOCK_INSTALL]: 'Sunlock Install',
  [JOB_TYPE_COMBO_LOCK_INSTALL]: 'Combo Lockbox Install',
  [JOB_TYPE_CODEBOX_INSTALL]: 'CodeBox Install',
  [JOB_TYPE_YARD_SIGN_TAKEDOWN]: 'Yard Sign Takedown',
  [JOB_TYPE_SUPRA_LOCK_TAKEDOWN]: 'Supra Lockbox Takedown',
  [JOB_TYPE_SUNLOCK_TAKEDOWN]: 'Sunlock Takedown',
  [JOB_TYPE_COMBO_LOCK_TAKEDOWN]: 'Combo Lockbox Takedown',
  [JOB_TYPE_CODEBOX_TAKEDOWN]: 'CodeBox Takedown',
  [JOB_TYPE_REPLACE_SUNLOCK_BATTERY]: 'Replace Sunlock Battery',
  [JOB_TYPE_CHECK_DOOR_LOCK]: 'Check Door Lock',
  [JOB_TYPE_CONFIRM_LISTING_INFORMATION]:
    srJobTypeTextMapping[JOB_TYPE_CONFIRM_LISTING_INFORMATION],
};

export const srJobChoices = [
  {
    id: JOB_TYPE_CONDITION_REPORT,
    label: 'Condition Report',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_PROPERTY_CHECK,
    label: 'Property Check',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_MEDIA,
    label: 'Photos',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_MEDIA_CURBSHOT,
    label: 'Curbshot',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_MEDIA_3D_TOUR,
    label: '3D Tour',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SPECIAL_REQUEST,
    label: 'Special Request',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_FIX,
    label: 'Fix',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_YARD_SIGN_SETUP,
    label: 'Yard Sign Setup',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SUPRA_LOCK_INSTALL,
    label: 'Supra Lockbox Install',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SUNLOCK_INSTALL,
    label: 'Sunlock Install',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_COMBO_LOCK_INSTALL,
    label: 'Combo Lockbox Install',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_CODEBOX_INSTALL,
    label: 'CodeBox Install',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_YARD_SIGN_TAKEDOWN,
    label: 'Yard Sign Takedown',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
    label: 'Supra Lockbox Takedown',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SUNLOCK_TAKEDOWN,
    label: 'Sunlock Takedown',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP,
    label: 'Green Residential Uninstall and New Lock Install',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_COMBO_LOCK_TAKEDOWN,
    label: 'Combo Lockbox Takedown',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_CODEBOX_TAKEDOWN,
    label: 'CodeBox Takedown',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_REPLACE_SUNLOCK_BATTERY,
    label: 'Replace Sunlock Battery',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_CHECK_DOOR_LOCK,
    label: 'Check Door Lock',
    type: 'checkbox',
  },
  {
    id: JOB_TYPE_CONFIRM_LISTING_INFORMATION,
    label: srJobTypeTextMapping[JOB_TYPE_CONFIRM_LISTING_INFORMATION],
    type: 'checkbox',
  },
];

const getPartnerJobPrefix = (partnerId) => {
  switch (partnerId) {
    case PARTNER_ID_STONE_OAK:
      return 'Stone Oak';
    case PARTNER_ID_HOMERIVER:
      return 'HomeRiver';
    case PARTNER_ID_3Z_PROPERTIES:
      return '3Z';
    default:
      return '';
  }
};

export function getJobTypeToActionMapping({ job, listing }) {
  switch (job.jobTypeId) {
    case JOB_TYPE_YARD_SIGN_SETUP: {
      if (!listing.partnerId) {
        return 'Install Yard Sign';
      }
      const partnerJobPrefix = getPartnerJobPrefix(listing.partnerId);
      return `Install ${partnerJobPrefix} Yard Sign`.trim();
    }
    case JOB_TYPE_SUPRA_LOCK_INSTALL:
      return 'Install Supra';
    case JOB_TYPE_SUNLOCK_INSTALL:
      return 'Install Sunlock';
    case JOB_TYPE_COMBO_LOCK_INSTALL:
      return 'Install Combo Lockbox';
    case JOB_TYPE_CODEBOX_INSTALL:
      return 'Install CodeBox';
    case JOB_TYPE_YARD_SIGN_TAKEDOWN:
      return 'Uninstall Sign';
    case JOB_TYPE_SUPRA_LOCK_TAKEDOWN:
      return 'Uninstall Supra';
    case JOB_TYPE_SUNLOCK_TAKEDOWN:
      return 'Uninstall Sunlock';
    case JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP:
      return 'Green Residential Uninstall and New Lock Install';
    case JOB_TYPE_COMBO_LOCK_TAKEDOWN:
      return 'Uninstall Combo Lockbox';
    case JOB_TYPE_CODEBOX_TAKEDOWN:
      return 'Uninstall CodeBox';
    case JOB_TYPE_PROPERTY_CHECK:
      return 'Property Check';
    case JOB_TYPE_MEDIA:
      return 'Take photos';
    case JOB_TYPE_MEDIA_CURBSHOT:
      return 'Curbshot';
    case JOB_TYPE_MEDIA_3D_TOUR:
      return '3D Tour Scan';
    case JOB_TYPE_FIX:
      return 'Fix';
    case JOB_TYPE_SPECIAL_REQUEST:
      return 'Special Request';
    case JOB_TYPE_CONDITION_REPORT:
      return 'Property Condition Report';
    case JOB_TYPE_REPLACE_SUNLOCK_BATTERY:
      return 'Replace Sunlock Battery';
    case JOB_TYPE_CHECK_DOOR_LOCK:
      return 'Check Door Lock';
    case JOB_TYPE_CONFIRM_LISTING_INFORMATION:
      return srJobTypeTextMapping[JOB_TYPE_CONFIRM_LISTING_INFORMATION];
  }
}

export const srJobTypeToSignOtterJobTypeMapping = {
  [JOB_TYPE_YARD_SIGN_SETUP]: SIGN_OTTER_JOB_TYPE_INSTALL,
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: SIGN_OTTER_JOB_TYPE_INSTALL,
  [JOB_TYPE_SUNLOCK_INSTALL]: SIGN_OTTER_JOB_TYPE_INSTALL,
  [JOB_TYPE_COMBO_LOCK_INSTALL]: SIGN_OTTER_JOB_TYPE_INSTALL,
  [JOB_TYPE_CODEBOX_INSTALL]: SIGN_OTTER_JOB_TYPE_INSTALL,

  [JOB_TYPE_YARD_SIGN_TAKEDOWN]: SIGN_OTTER_JOB_TYPE_UNINSTALL,
  [JOB_TYPE_SUPRA_LOCK_TAKEDOWN]: SIGN_OTTER_JOB_TYPE_UNINSTALL,
  [JOB_TYPE_SUNLOCK_TAKEDOWN]: SIGN_OTTER_JOB_TYPE_UNINSTALL,
  [JOB_TYPE_COMBO_LOCK_TAKEDOWN]: SIGN_OTTER_JOB_TYPE_UNINSTALL,
  [JOB_TYPE_CODEBOX_TAKEDOWN]: SIGN_OTTER_JOB_TYPE_UNINSTALL,
};

export const signOtterItemTypeToSrInstallJobTypeMapping = {
  [SIGN_OTTER_ITEM_TYPE_YARD_SIGN]: JOB_TYPE_YARD_SIGN_SETUP,
  [SIGN_OTTER_ITEM_TYPE_SUPRA_LOCK]: JOB_TYPE_SUPRA_LOCK_INSTALL,
  [SIGN_OTTER_ITEM_TYPE_SUNLOCK]: JOB_TYPE_SUNLOCK_INSTALL,
  [SIGN_OTTER_ITEM_TYPE_COMBO_LOCK]: JOB_TYPE_COMBO_LOCK_INSTALL,
};

export const signOtterItemTypeToSrTakedownJobTypeMapping = {
  [SIGN_OTTER_ITEM_TYPE_YARD_SIGN]: JOB_TYPE_YARD_SIGN_TAKEDOWN,
  [SIGN_OTTER_ITEM_TYPE_SUPRA_LOCK]: JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
  [SIGN_OTTER_ITEM_TYPE_SUNLOCK]: JOB_TYPE_SUNLOCK_TAKEDOWN,
  [SIGN_OTTER_ITEM_TYPE_COMBO_LOCK]: JOB_TYPE_COMBO_LOCK_TAKEDOWN,
};

export const srJobTypeToDriverJobMapping = {
  [JOB_TYPE_YARD_SIGN_SETUP]: 'Sign',
  [JOB_TYPE_SUPRA_LOCK_INSTALL]: 'Supra',
  [JOB_TYPE_SUNLOCK_INSTALL]: 'Sunlock',
  [JOB_TYPE_COMBO_LOCK_INSTALL]: 'Combo Lockbox',
  [JOB_TYPE_CODEBOX_INSTALL]: 'CodeBox',

  [JOB_TYPE_YARD_SIGN_TAKEDOWN]: 'Sign',
  [JOB_TYPE_SUPRA_LOCK_TAKEDOWN]: 'Supra',
  [JOB_TYPE_SUNLOCK_TAKEDOWN]: 'Sunlock',
  [JOB_TYPE_COMBO_LOCK_TAKEDOWN]: 'Combo Lockbox',
  [JOB_TYPE_CODEBOX_TAKEDOWN]: 'CodeBox',
  [JOB_TYPE_PROPERTY_CHECK]: 'Property Check',
  [JOB_TYPE_MEDIA]: 'Photos',
  [JOB_TYPE_FIX]: 'Fix',
  [JOB_TYPE_REPLACE_SUNLOCK_BATTERY]: 'Replace Sunlock Battery',
  [JOB_TYPE_CHECK_DOOR_LOCK]: 'Check Door Lock',
  [JOB_TYPE_CONFIRM_LISTING_INFORMATION]:
    srJobTypeTextMapping[JOB_TYPE_CONFIRM_LISTING_INFORMATION],
  [JOB_TYPE_MEDIA_3D_TOUR]: srJobTypeTextMapping[JOB_TYPE_MEDIA_3D_TOUR],
};

export const srJobStatusToDriverStatusMapping = {
  [JOB_STATUS_CREATED]: 'Not Started',
  [JOB_STATUS_COMPLETED]: 'Complete',
  [JOB_STATUS_FAILED]: 'Incomplete',
  [JOB_STATUS_CANCELLED]: 'Cancelled',
};

export const JOB_PHOTOGRAPHY_STATUSES = [
  JOB_PHOTOGRAPHY_STATUS_SUBMITTED,
  JOB_PHOTOGRAPHY_STATUS_PULLED,
  JOB_PHOTOGRAPHY_STATUS_OPEN,
  JOB_PHOTOGRAPHY_STATUS_ARRIVED,
  JOB_PHOTOGRAPHY_STATUS_TRIP_COMPLETE,
  JOB_PHOTOGRAPHY_STATUS_UPLOADED,
];

export const JOB_LOCK_TEST_TYPES = [
  JOB_TYPE_SUNLOCK_INSTALL,
  JOB_TYPE_CODEBOX_INSTALL,
  JOB_TYPE_FIX,
  JOB_TYPE_REPLACE_SUNLOCK_BATTERY,
  JOB_TYPE_CHECK_DOOR_LOCK,
  JOB_TYPE_PROPERTY_CHECK,
];

export const JOB_ORDER_LOCK_TEST_FAILED_STATUSES = [JOB_STATUS_FAILED, JOB_STATUS_CANCELLED];

export const JOB_LOCK_TEST_ERROR_MESSAGE =
  'This Sunlock has not been successfully tested or has failed testing. Please call Field Operations Support at (512) 957-0512 for troubleshooting to ensure it is functioning properly.'; // eslint-disable-line max-len

export const JOB_ORDER_UNINSTALL_REASON_LEASED = 'Leased';
export const JOB_ORDER_UNINSTALL_REASON_OWNER_SOLD_PROPERTY = 'OwnerSoldProperty';
export const JOB_ORDER_UNINSTALL_REASON_OWNER_NOT_INTERESTED = 'OwnerNotInterested';
export const JOB_ORDER_UNINSTALL_REASON_OTHER = 'Other';

export const JOB_ORDER_UNINSTALL_REASON_OPTION_ITEMS = [
  {
    label: 'Leased',
    value: JOB_ORDER_UNINSTALL_REASON_LEASED,
  },
  {
    label: 'Owner decided to sell the property',
    value: JOB_ORDER_UNINSTALL_REASON_OWNER_SOLD_PROPERTY,
  },
  {
    label: 'Owner does not want our leasing services anymore',
    value: JOB_ORDER_UNINSTALL_REASON_OWNER_NOT_INTERESTED,
  },
  {
    label: 'Other',
    value: JOB_ORDER_UNINSTALL_REASON_OTHER,
  },
];

export const PARTNER_IDS_WITH_YARD_SIGN_BOTTOM_RIDER = [
  PARTNER_ID_3Z_PROPERTIES,
  PARTNER_ID_STONE_OAK,
];

export const PROPERTY_CONDITION_REPORT_JOB_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSdCK5bG9C2ycJ0gsPU5fJGt4RmVc5HSVOErP4-MkpZPiF5WMg/viewform';

export const getStatusColor = (status) => {
  switch (status) {
    case JOB_STATUS_CANCELLED:
    case JOB_STATUS_FAILED:
      return 'red';
    case JOB_STATUS_COMPLETED:
      return 'green';
    default:
      return 'orange300';
  }
};
